import { ReadWriteRecipientViewState } from 'owa-recipient-common';
import { action } from 'satcheljs';

const addPersonsAdvancedSearch = action(
    'addPersonsAdvancedSearch',
    (personsToAdd: ReadWriteRecipientViewState[], isFromPicker: boolean) => ({
        personsToAdd,
        isFromPicker,
    })
);

export default addPersonsAdvancedSearch;
